import Vue from 'vue'
import template from './_payment-confirm.pug'

export default Vue.extend({
  template: template(),
  props: {
    text: {
      type: String,
      default: undefined
    },
    rechargeData: {
      type: Object,
      default() {
        return {
          amount: undefined,
          bonus_amount: undefined,
          buy_order: undefined,
          media_code: undefined,
          media_type: undefined,
          pay_url: undefined,
          retries: undefined,
          state: undefined,
          token: undefined,
          trans_date: undefined,
          id: undefined,
          administrative_area_name: undefined,
          is_nominal: undefined,
          municipality_name_normalized: undefined,
          country_alpha2: undefined
        }
      }
    }
  },
  data() {
    return {
      web_title: Vue.store.state.webTitle
    }
  },
  computed: {
    moverickDateTime() {
      return moment.utc().format('DD/MM/YYYY HH:mm')
    },

    cardResponse() {
      // Verifica si es recarga de saldo o producto
      return localStorage.getItem('cardResponse') === 'true'
    },
    rechargeBonusAmount() {
      return this.rechargeData.bonus_amount || this.rechargeData.amount
    },
    rechargeBonus() {
      const {bonus_amount, amount} = this.rechargeData
      if (!bonus_amount || !amount) { return 0 }

      return bonus_amount - amount
    }
  },
  methods: {
    calculateBalanceUrl() {
      this.$router.push({
        name: 'municipality-data-balance',
        params: {
          country: this.rechargeData.country_alpha2,
          municipality: this.rechargeData.municipality_name_normalized
        }
      })
    },
    showConditions() {
      const routeData = this.$router.resolve({name: 'privacy-policy'})
      window.open(routeData.href)
    },
    showPrivacy() {
      const routeData = this.$router.resolve({name: 'privacy-policy-text'})
      window.open(routeData.href)
    }
  }
})
